import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, switchMap, take, takeUntil } from 'rxjs/operators';
import { Destroyer } from 'src/app/core/abstract/destroyer';
import { Idea } from 'src/app/core/models/idea.models';
import { AuthStoreService } from 'src/app/core/store/services/auth-store.service';
import { IdeasLikesStoreService } from 'src/app/core/store/services/ideas-store-likes.service';

@Component({
  selector: 'craft-votes-button',
  templateUrl: './craft-votes-button.component.html',
  styleUrls: ['./craft-votes-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CraftVotesButtonComponent extends Destroyer implements OnInit {
  @Input() public idea: Readonly<Idea>;
  @Input() public disabled = false;

  public clicks = new Subject<MouseEvent>();

  constructor(
    private authStore: AuthStoreService, //
    private ideasLikesStore: IdeasLikesStoreService,
  ) {
    super();
  }

  public ngOnInit() {
    this.clicks
      .pipe(
        filter((event) => event.button === 0 && !!this.idea.id),
        switchMap(() => {
          return this.authStore.isAuthenticated$.pipe(take(1));
        }),
        switchMap((isAuthenticated) => {
          if (!isAuthenticated) return this.authStore.logout();

          return this.idea.isVoted
            ? this.ideasLikesStore.deleteVote(this.idea.id!) //
            : this.ideasLikesStore.addVote(this.idea.id!);
        }),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }
}
